import { useState, useEffect, FormEvent } from "react";
import AdminLayout from "../components/AdminLayout";
import { supabase } from "../../../lib/supabase";

export default function AdminSettings() {
  const [headerTextColor, setHeaderTextColor] = useState("#000000");
  const [headerBgColor, setHeaderBgColor] = useState("#FFFFFF");
  const [bannerCollectionName, setBannerCollectionName] = useState("PRE FALL'26");
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    const fetchSettings = async () => {
      const { data } = await supabase.from("site_settings").select("*");
      if (data) {
        data.forEach((row: { key: string; value: string }) => {
          if (row.key === "header_text_color") setHeaderTextColor(row.value ?? "#000000");
          if (row.key === "header_bg_color") setHeaderBgColor(row.value ?? "#FFFFFF");
          if (row.key === "banner_collection_name") setBannerCollectionName(row.value ?? "PRE FALL'26");
        });
      }
      setLoading(false);
    };
    fetchSettings();
  }, []);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setSaving(true);

    await Promise.all([
      supabase.from("site_settings").upsert({ key: "header_text_color", value: headerTextColor, updated_at: new Date().toISOString() }),
      supabase.from("site_settings").upsert({ key: "header_bg_color", value: headerBgColor, updated_at: new Date().toISOString() }),
      supabase.from("site_settings").upsert({ key: "banner_collection_name", value: bannerCollectionName, updated_at: new Date().toISOString() }),
    ]);

    setSaving(false);
    setSaved(true);
    setTimeout(() => setSaved(false), 3000);
  };

  if (loading) {
    return (
      <AdminLayout>
        <div className="text-[11px] text-black/40">Carregando...</div>
      </AdminLayout>
    );
  }

  return (
    <AdminLayout>
      <div className="max-w-xl">
        <div className="mb-8">
          <h1 className="text-xl font-light tracking-[0.15em] text-black uppercase" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
            Configurações
          </h1>
          <p className="text-[11px] tracking-wide text-black/40 mt-1">
            Personalize a aparência do site
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">

          {/* Header colors */}
          <div className="bg-white border border-black/8 rounded-lg p-5">
            <h3 className="text-[11px] tracking-[0.2em] font-semibold text-black uppercase mb-4">
              Cores do Header
            </h3>

            <div className="rounded-lg overflow-hidden mb-4 border border-black/8">
              <div
                className="h-12 flex items-center justify-center px-4 transition-colors"
                style={{ backgroundColor: headerBgColor }}
              >
                <span
                  className="text-[11px] tracking-[0.2em] font-medium transition-colors"
                  style={{ color: headerTextColor }}
                >
                  Preview Header
                </span>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="block text-[10px] tracking-[0.2em] text-black/50 mb-2 uppercase">
                  Cor das Fontes
                </label>
                <div className="flex items-center gap-2 border-b border-black/20 pb-2">
                  <input
                    type="color"
                    value={headerTextColor}
                    onChange={(e) => setHeaderTextColor(e.target.value)}
                    className="w-7 h-7 rounded cursor-pointer border-0 bg-transparent"
                  />
                  <input
                    type="text"
                    value={headerTextColor}
                    onChange={(e) => setHeaderTextColor(e.target.value)}
                    className="flex-1 bg-transparent text-sm outline-none"
                  />
                </div>
              </div>

              <div>
                <label className="block text-[10px] tracking-[0.2em] text-black/50 mb-2 uppercase">
                  Cor de Fundo
                </label>
                <div className="flex items-center gap-2 border-b border-black/20 pb-2">
                  <input
                    type="color"
                    value={headerBgColor}
                    onChange={(e) => setHeaderBgColor(e.target.value)}
                    className="w-7 h-7 rounded cursor-pointer border-0 bg-transparent"
                  />
                  <input
                    type="text"
                    value={headerBgColor}
                    onChange={(e) => setHeaderBgColor(e.target.value)}
                    className="flex-1 bg-transparent text-sm outline-none"
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Banner */}
          <div className="bg-white border border-black/8 rounded-lg p-5">
            <h3 className="text-[11px] tracking-[0.2em] font-semibold text-black uppercase mb-1">
              Banner da Coleção
            </h3>

            <div className="rounded-lg overflow-hidden mb-4 border border-black/8 bg-[#1a1a1a] relative h-16 flex items-center justify-center">
              <span className="text-white/20 font-bold tracking-[0.08em]">
                {bannerCollectionName}
              </span>
            </div>

            <input
              type="text"
              value={bannerCollectionName}
              onChange={(e) => setBannerCollectionName(e.target.value)}
              className="w-full border-b border-black/20 bg-transparent py-2 text-[12px] outline-none"
            />
          </div>

          <button
            type="submit"
            disabled={saving}
            className="bg-black text-white text-[11px] tracking-[0.2em] uppercase px-6 py-3 rounded-md"
          >
            {saving ? "Salvando..." : "Salvar"}
          </button>

          {saved && (
            <p className="text-[11px] text-green-600">Salvo com sucesso!</p>
          )}
        </form>
      </div>
    </AdminLayout>
  );
}